import Color from '../Color.mjs'
import superMeta from '../_ARCH/metaArchNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GOLD,
    alias: '需求池结构',
    archName: '需求地图',
    archUrl: '/ProjectSfMap',
    detailUrl: '/RaDetail',
    detailIdProp: 'raId',
    mapProp: 'raMap',
    moduleType: 'RM',
    name: '需求池结构',
    type: 'RA',
}
